import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import ReadMore from 'components/Components/UI/ReadMore';
import getFinalAttribute from 'utils/alternative-attribute';
import { isEmpty } from 'lodash';

/*
const DEFAULT_AMENITIES = [
    'One-way airport-hotel transfer',
    'Daily Breakfast',
    'Early check in & Late check-out (subject to availability)',
    'Room Upgrade (subject to availability)',
    'Spa credit',
    'Welcome amenity',
];
*/
function HotelPageOverview({ hotel })
{
    // const amenities = hotel.virtuoso_amenities ? hotel.virtuoso_amenities.split(/\r?\n/).slice(0, 3) : DEFAULT_AMENITIES;

    return (
        <section id="overview" className="tw-py-10 lg:tw-py-20 tw-px-4 tw-bg-gray-300">
            <div className="xl:tw-container tw-text-center">
                <Fade bottom>
                    <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">Overview</h2>
                </Fade>

                <Fade bottom>
                    <div className="tw-flex tw-flex-wrap tw-mt-12 tw-text-left tw-justify-center">
                        <div className="tw-flex md:tw-flex-nowrap tw-flex-wrap tw-w-11/12 ">
                            <div className="tw-flex md:tw-w-full tw-w-full tw-flex-wrap tw-pb-6 tw-border-b tw-border-gray-500 tw-mt-4 md:tw-mt-0">
                                <div className="tw-w-full tw-justify-center">
                                    <p className="tw-uppercase font-sp tw-mb-2 tw-text-center">Rating</p>
                                    <p className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-text-center">5/5</p>
                                </div>
                                <div className="tw-w-full">
                                    <p className="tw-uppercase font-sp tw-mb-2 tw-text-center">Room Types</p>
                                    <p className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-text-center">
                                        { !isEmpty(hotel.hotelRooms)
                                            ? hotel.hotelRooms.length
                                            : '-'
                                        }
                                    </p>
                                </div>
                            </div>
                            {/*
                            <div className="md:tw-w-1/2 tw-w-full tw-pb-6 lg:tw-pb-0 tw-border-b tw-border-gray-500">
                                <p className="tw-uppercase font-sp tw-mb-6  tw-text-center">Amenities</p>
                                <ReadMore max={1000}>
                                    <ul className="tw-flex tw-flex-wrap tw-justify-center">
                                        {amenities.map((amenity, key) => (
                                            <li className="tw-w-full  tw-flex tw-mb-1 md:tw-mb-3 tw-pr-4" key={key}>
                                                <span className="material-icons tw-align-middle tw-mr-3">done</span>
                                                <p>{amenity}</p>
                                            </li>
                                        ))
                                        }
                                    </ul>
                                </ReadMore>
                            </div>
                            */}
                        </div>

                        <div className="description-container tw-w-full lg:tw-pl-8  lg:tw-border-gray-500">
                            <p className="tw-uppercase font-sp tw-mb-4 lg:tw-mb-6 tw-mt-10">Description</p>
                            <ReadMore
                                textClass="tw-font-normal tw-text-2xl tw-mb-4 lg:tw-mb-6"
                                max={500}
                            >
                                {getFinalAttribute(hotel, 'description')}
                            </ReadMore>
                        </div>
                    </div>
                </Fade>
            </div>
        </section>
    );
}

HotelPageOverview.propTypes = {
    hotel: PropTypes.object.isRequired,
};

export default HotelPageOverview;
